import { DeleteOutlined, EditOutlined } from '@ant-design/icons'

import { memo, useState } from 'react'
import { ButtonCommon, FormSingleField, PopoverCommon } from 'src/common'
import PopconfirmCommon from 'src/common/PopconfirmCommon/PopconfirmCommon'
import { useAppDispatch, useAppSelector, useModalCommon } from 'src/hooks'
import {
	onDeleteMeaning,
	onUpdateMeaning,
} from 'src/redux/definition/definition.actions'
import { selectCurrentDictWordIDFromDef } from 'src/redux/definition/definition.selector'
import { showMessageError, showMessageSuccess } from 'src/utils/function.utils'
import Examples from '../Examples/Examples'
import './MeaningItem.scss'

const MeaningItem = memo(({ id, definition, examples }) => {
	const dispatch = useAppDispatch()
	const dictWordID = useAppSelector(selectCurrentDictWordIDFromDef)
	const {
		visible: visibleModalDelete,
		openModal: openModalDelete,
		closeModal: closeModalDelete,
	} = useModalCommon()

	const [isDeleteLoading, setIsDeleteLoading] = useState(false)

	const handleEdit = value => {
		dispatch(
			onUpdateMeaning(
				{
					id,
					dictWordID,
					definition: value,
				},
				onSubmitCb
			)
		)
	}

	const onSubmitCb = (isSuccess, rs) => {
		if (isSuccess) {
			showMessageSuccess()
		} else {
			showMessageError(rs)
		}
	}

	// delete
	const handleDelete = () => {
		setIsDeleteLoading(true)
		dispatch(
			onDeleteMeaning(
				{
					id,
				},
				handleDeleteCb
			)
		)
	}

	const handleDeleteCb = (isSuccess, rs) => {
		setIsDeleteLoading(false)
		if (isSuccess) {
			showMessageSuccess('Delete successfully')
		} else {
			showMessageError(rs)
		}
	}

	return (
		<li className="meaing-item">
			<div className="content">
				{definition && (
					<div className="u-row-between">
						<div className="definition">
							<span>{definition}</span>
						</div>
						<div className="u-row">
							<PopconfirmCommon
								visible={visibleModalDelete}
								onConfirm={handleDelete}
								title="Are you sure to delete this meaning and related examples permanently?"
								placement="left"
								okButtonProps={{ loading: isDeleteLoading }}
								onCancel={closeModalDelete}
							>
								<ButtonCommon
									icon={<DeleteOutlined />}
									// size="small"
									ghost
									type="danger"
									onClick={openModalDelete}
								></ButtonCommon>
							</PopconfirmCommon>
							<PopoverCommon
								trigger="click"
								content={
									<FormSingleField
										initialValue={definition}
										label="Meaning"
										fieldName="definition"
										onSubmit={handleEdit}
										isRequired
									/>
								}
							>
								<ButtonCommon
									icon={<EditOutlined />}
									// size="small"
									ghost
									type="primary"
								></ButtonCommon>
							</PopoverCommon>
						</div>
					</div>
				)}
				<Examples
					dictWordID={dictWordID}
					examples={examples}
					wordMeaningID={id}
				/>
			</div>
		</li>
	)
})

export default MeaningItem
